import type {
  ConditionField,
  DraggableFieldType,
  DraggableMetaType,
  FieldWrapper,
  ReportField,
} from "../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../api/types/svTypes.ts";
import { isIrr } from "../../../utilities/fieldsHelper.ts";
import { createConditionField, createTabularField } from "../common/utilities/createFields.ts";
import { extractMeta } from "../common/utilities/dropFieldContainerHelper.ts";
import { isDimensionMeta, isIrrMeasureMeta } from "../common/utilities/metaUtils.ts";

export const canDropCashFlowField = (
  item: FieldWrapper<DraggableFieldType> | DraggableMetaType,
  fields: ReportField[],
  readonly: boolean
): boolean => {
  if (readonly) {
    return false;
  }
  const meta = extractMeta(item);
  return (
    !!meta &&
    ((isIrrMeasureMeta(meta) && !fields.some(isIrr)) ||
      (isDimensionMeta(meta) &&
        meta.type === ItemDataType.General &&
        !fields.some((field) => field.config.name === meta.name)))
  );
};

export const createCashFlowField = (meta: DraggableMetaType): ReportField | undefined => {
  if (isDimensionMeta(meta) && meta.type === ItemDataType.General) {
    return createTabularField(meta);
  }
  if (!isIrrMeasureMeta(meta)) {
    return undefined;
  }
  const field = createTabularField(meta);
  return isIrr(field) ? { ...field, config: { ...field.config, includeCashFlowDetails: true } } : undefined;
};

export const canDropCashFlowSplitField = (
  item: FieldWrapper<DraggableFieldType> | DraggableMetaType,
  hasSplitField: boolean,
  readonly: boolean
): boolean => {
  const meta = extractMeta(item);
  return !readonly && !hasSplitField && !!meta && isDimensionMeta(meta) && meta.type === ItemDataType.General;
};

export const createCashFlowSplitField = (meta: DraggableMetaType): ConditionField | undefined => {
  return isDimensionMeta(meta) && meta.type === ItemDataType.General ? createConditionField(meta) : undefined;
};
